

import type { LoginUser, MstItem, StockPlanUpdateBase, ResponseResult } from 'api-client'
import type { User } from 'firebase/auth'

// Extend Stock interface with additional properties added at runtime
declare module 'api-client' {
  interface Stock {
    itemName?: string | null
    janCase?: string | null
    orderUnitTypeName?: string | null
    caseLot?: number | null
    minOrderQuantity?: number | null
    weight?: number | null
    maxPalletQuantity?: number | null
    supplierName?: string | null
    orderUnitType?: string | null
  }
}

type GridSortDirection = 'asc' | 'desc' | null | undefined
type GridSortItem = { readonly field: string; readonly sort: GridSortDirection }
type GridSortModel = readonly GridSortItem[]
type GridPaginationModel = { pageSize: number; page: number }
type GridRowId = string | number

export interface DataListStatus {
  listCenterId?: number | null
  sortModel: GridSortModel
  paginationModel: GridPaginationModel
}
export const initDataListStatus = (): DataListStatus => ({
  sortModel: [],
  paginationModel: {
    pageSize: 100,
    page: 0,
  },
})

export interface ErrorResponse {
  response: Response
}

export type LoginUserWithMfa = LoginUser & {
  isMfaEnabled: boolean
  mfaTel: string | null
}

export type MfaUser = User & {
  reloadUserInfo?: ReloadUserInfo
}

export type ReloadUserInfo = {
  mfaInfo?: MfaInfo[]
}

export type MfaInfo = {
  phoneInfo: string
}

export interface DataListStockUpdate extends StockPlanUpdateBase {
  id: GridRowId
  oldArrivalQuantityPlan?: number
  oldShipQuantityPlan?: number
}

export interface DataListItemUpdate extends MstItem {
  id: string
}

export interface MessageInfoType {
  status: string | null;
  message: string | null;
}
export const initMessageInfo = (): MessageInfoType => ({ status: null, message: null })
export const clearMessageInfo = (): ResponseResult => ({ status: null, message: null, pageNo: 0, systemDate: null, systemInfo: null })

export const isSameResponseResult = (a?: ResponseResult, b?: ResponseResult): boolean => {
  if (a === b) return true
  if (!a || !b) return !a && !b
  return (
    a.status === b.status &&
    a.message === b.message &&
    a.systemDate === b.systemDate &&
    a.pageNo === b.pageNo
  )
}

